type GAOptions = {
  hitCallback?: () => void;
};

function createFunctionWithTimeout(callback) {
  let called = false;

  function fn() {
    if (!called) {
      called = true;
      callback();
    }
  }

  setTimeout(fn, 500);
  return fn;
}

export function sendEvent(
  eventCategory: string,
  eventAction?: string,
  eventLabel?: string,
  callback?: (value?: unknown) => Promise<void> | void,
  eventValue?: string,
): void {
  const opts: GAOptions = {};

  if (window.ga) {
    if (typeof callback === 'function') {
      opts.hitCallback = createFunctionWithTimeout(callback);
    }

    window.ga(
      'send',
      'event',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      opts,
    );
  } else {
    console.warn('window.ga is not defined. Call args: ', [
      'send',
      'event',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
    ]);

    callback && callback();
  }
}
